module.exports = __webpack_public_path__ + "media/images/p-about/example/coop-energy-nara-eb85bba7d6c2b07f4fcd95b9963d99ac.jpg";